import * as t from './actionTypes';

export const initialState = {
  isFetching: false,
  error: null,
  byMedium: {},
};

export const scheduledMessagesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.DELETE_SCHEDULED_MESSAGES_ERROR:
    case t.DELETE_ALL_SCHEDULED_MESSAGES_ERROR:
    case t.FETCH_SCHEDULED_MESSAGES_ERROR: {
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };
    }

    case t.DELETE_SCHEDULED_MESSAGES_RESPONSE: {
      const { messageMedium, ids } = action.payload;

      return {
        ...state,
        byMedium: {
          ...state.byMedium,
          [messageMedium]: state.byMedium[messageMedium].filter((msg) => !ids.includes(msg.id)),
        },
        error: null,
        isFetching: false,
      };
    }

    case t.DELETE_ALL_SCHEDULED_MESSAGES_RESPONSE: {
      const { messageMedium } = action.payload;
      return {
        ...state,
        byMedium: {
          ...state.byMedium,
          [messageMedium]: [],
        },
        error: null,
        isFetching: false,
      };
    }

    case t.FETCH_SCHEDULED_MESSAGES_RESPONSE: {
      return {
        ...state,
        error: null,
        isFetching: false,
        byMedium: action.payload,
      };
    }

    case t.DELETE_SCHEDULED_MESSAGES_REQUEST:
    case t.DELETE_ALL_SCHEDULED_MESSAGES_REQUEST:
    case t.FETCH_SCHEDULED_MESSAGES_REQUEST: {
      return {
        ...state,
        isFetching: true,
      };
    }

    default: {
      return state;
    }
  }
};
